module.exports = __webpack_public_path__ + "img/pagebanner-shop.f6eb25b7.jpg";